import {UserInput} from "../../http/protocol";
import {UseFormRegister, UseFormWatch} from "react-hook-form/dist/types/form";
import {FieldErrors} from "react-hook-form/dist/types/errors";
import {RegisterOptions} from "react-hook-form/dist/types/validator";
import {useFormContext} from "react-hook-form";
import {ShowHidePassword} from "../../user/ui/ShowHidePassword";
import * as React from "react";
import {formText} from "../user-utils";
import {t} from "../../i18n";

export const UserDetailsPasswordInput = (props : {input : UserInput, repeat? : string, name: string, register : UseFormRegister<any>, errors : FieldErrors<any>, watch :  UseFormWatch<any>, options : RegisterOptions, handleFocus: any }) => {
    const {name, register, errors, options, watch} = props;
    const hasError = !!errors[name]
    const {nameText, invalidText, helpText} = formText(name);

    let {getValues} = useFormContext();
    let repeatOptions : RegisterOptions = {
        validate : (value) => {
            if(props.repeat &&  value && value === getValues(props.repeat as any)) {
                return true;
            }
            return false;
        }
    }
    return (
        <div onBlur={props.handleFocus} className={"form-group " +  (hasError ? "has-error" : "")}>
            <ShowHidePassword>
                <label className={"forms-label"} htmlFor={name}>{nameText}</label>
                <input onFocus={props.handleFocus} id={name} autoComplete={"new-password"} className={`form-control`} placeholder={nameText} type={"password"} tabIndex={0}  {...register(name, props.repeat ? repeatOptions : options)}/>
            </ShowHidePassword>
            {helpText.length > 0 && !hasError &&  <span className="help-block">{helpText}</span>}
            <div className="password-requirements-text">{t('user.password-requirements')}</div>
        </div>
    )
}